export default "__VITE_ASSET__DaoM5HHw__"